import { gql } from '@apollo/client'

export const LIST_PHOTOSPHEREPHOTOS = gql`
  query PhotospherePhotos {
    listPhotospherePhotos {
      data {
        id
        title
        image
        slug
        initialPitch
        initialYaw
        hotspots {
          pitch
          yaw
          text
          type
          transition {
            slug
          }
          url
        }
      }
    }
  }
`